function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import { Flex } from '../Flex';

var IconField = function IconField(props) {
  var isIcon = function isIcon(item) {
    return item.type.isIcon || item.type.isIconButton;
  };

  var children = React.Children.toArray(props.children).filter(function (child) {
    return (child === null || child === void 0 ? void 0 : child.type.isField) || isIcon(child);
  });

  if (children.length === 0) {
    return null;
  }

  var inputIndex = children && children.findIndex(function (child) {
    return child.type.isField;
  });
  var prefixIcons = children.slice(0, inputIndex);
  var input = children[inputIndex];
  var suffixIcons = children.slice(inputIndex + 1, children.length);
  var paddingLeft = prefixIcons.length > 0 ? prefixIcons.length * 40 : undefined;
  var paddingRight = suffixIcons.length > 0 ? suffixIcons.length * 40 : undefined;
  var marginRight = prefixIcons.length > 0 ? -(prefixIcons.length * 40) : undefined;
  var marginLeft = suffixIcons.length > 0 ? -(suffixIcons.length * 40) : undefined;
  return /*#__PURE__*/React.createElement(Flex, _extends({
    alignItems: "center"
  }, props), prefixIcons.length > 0 && /*#__PURE__*/React.createElement(Flex, {
    mr: marginRight,
    "data-testid": "icon-field-prefix-icons"
  }, prefixIcons.map(function (icon, index) {
    return /*#__PURE__*/React.cloneElement(icon, {
      ml: index === 0 ? 2 : 0,
      mr: 2
    });
  })), input && /*#__PURE__*/React.cloneElement(input, {
    pl: paddingLeft,
    pr: paddingRight
  }), suffixIcons.length > 0 && /*#__PURE__*/React.createElement(Flex, {
    ml: marginLeft,
    "data-testid": "icon-field-suffix-icons"
  }, suffixIcons.map(function (icon, index) {
    return /*#__PURE__*/React.cloneElement(icon, {
      ml: 2,
      mr: index === 0 ? 2 : 0
    });
  })));
};

IconField.propTypes = {
  children: PropTypes.node
};
export default IconField;